import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Combobox option-row variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const comboboxOptionVariants = cva(
  [
    'flex w-full items-center gap-xxs',
    'px-xs py-xxs',
    'text-left no-underline',
    'border-b border-neutral-100 last:border-b-0',
    'transition-colors duration-fast',
    'focus:outline-none',
  ],
  {
    variants: {
      state: {
        default: 'bg-white hover:bg-neutral-100 focus:bg-neutral-100',
        active: 'bg-neutral-100',
        selected: 'bg-secondary-50 text-secondary-700',
        disabled: 'cursor-not-allowed bg-neutral-100 text-neutral-200',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  },
);

export type ComboboxOptionVariantProps = VariantProps<
  typeof comboboxOptionVariants
>;
